const PRODUCTS_LIST_CLASSES_PREFIX = "products-list";

export const PRODUCTS_LIST_CLASSES = {
  productGrid: `${PRODUCTS_LIST_CLASSES_PREFIX}-productGrid`,
};
